import { render, staticRenderFns } from "./Plan.vue?vue&type=template&id=3aea9a46&scoped=true&lang=html&"
import script from "./Plan.vue?vue&type=script&lang=ts&"
export * from "./Plan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aea9a46",
  null
  
)

export default component.exports